<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-import"
      header-title="Import"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <PtSheet>
      <v-form v-model="validForm" @submit.prevent="confirm">
        <v-text-field
          outlined
          dense
          label="Sftp User Name"
          v-model="sftpUsername"
          :input="hasSftpUsername"
          :rules="[rules.required('Sftp Username')]"
        />
        <v-checkbox
          dense
          :disabled="!hasSftpUsername"
          label="Use Invoice Data"
          v-model="useInvoiceData"
          @change="$event || (parserClass = null)"
        >
        </v-checkbox>

        <v-select
          v-if="useInvoiceData"
          outlined
          clearable
          dense
          v-model="parserClass"
          :items="parsers"
          label="Invoice Parser Class Name"
          :rules="[rules.required('Parser Name')]"
        ></v-select>

        <v-checkbox
          dense
          :disabled="!hasSftpUsername"
          label="Use SFTP Vendor File"
          v-model="useSftpVendorFile"
        ></v-checkbox>

        <v-btn type="submit" color="primary" :disabled="!validForm">
          Save
        </v-btn>
      </v-form>
    </PtSheet>

    <v-dialog v-model="confirmationDialog" width="672">
      <v-card class="pt-8 pb-4 d-flex flex-column align-center">
        <v-card-title class="pt-0 colorNeutralsNavy400--text headline">
          Change the File Import Settings?
        </v-card-title>

        <v-card-text class="text-center colorNeutralsNavy400--text body1">
          This will change the file import setting for {{ client }}.
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="cancel" class="px-4">
            <v-icon left small class="ml-n1">mdi-close</v-icon>
            Cancel
          </v-btn>
          <v-btn outlined color="primary" @click="save" class="px-4">
            <v-icon left small class="ml-n1">mdi-check</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { get, put } from "@/services/request";
import { importConfigAPI } from "@/services/api";
import hasCurrentUser from "@/mixins/has-current-user";
import hasNotifications from "@/mixins/has-notifications";
import * as rules from "@/services/rules";
import PtSheet from "@/components/PtSheet.vue";
import ContentHeader from "@/views/ContentHeader.vue";

export default {
  name: "AdminImport",
  components: { ContentHeader, PtSheet },

  mixins: [hasCurrentUser, hasNotifications],

  data: () => ({
    useInvoiceData: null,
    useSftpVendorFile: null,
    parserClass: null,
    parsers: [],
    validForm: false,
    rules,
    sftpUsername: "",
    client: "",
    confirmationDialog: false
  }),

  created() {
    this.getImportData();
  },
  computed: {
    hasSftpUsername() {
      return this.sftpUsername ? true : false;
    }
  },
  methods: {
    confirm() {
      this.confirmationDialog = true;
    },
    cancel() {
      this.confirmationDialog = false;
    },
    save() {
      this.confirmationDialog = false;
      put(importConfigAPI.getUrl(this.currentUser.clientId), {
        useInvoiceData: this.useInvoiceData,
        useSftpVendorFile: this.useSftpVendorFile,
        invoiceParserClassName: this.parserClass,
        sftpUsername: this.sftpUsername
      }).then(
        () => {
          this.showMessage("Save successfully.");
        },
        err => {
          this.showMessage({
            mode: "error",
            text: "Save failed. Double check the Sftp User Name."
          });
          console.error(err);
        }
      );
    },
    getImportData() {
      get(importConfigAPI.getUrl(this.currentUser.clientId)).then(
        response => {
          if (response && response.data) {
            this.useInvoiceData = response.data.useInvoiceData;
            this.useSftpVendorFile = response.data.useSftpVendorFile;
            this.parsers = response.data.validClasses;
            this.parserClass = response.data.invoiceParserClassName;
            this.sftpUsername = response.data.sftpUsername;
            this.client = response.data.clientName;
          }
        },
        err => {
          this.showMessage({
            mode: "error",
            text: "Failed to load client import config."
          });
          console.error(err);
        }
      );
    }
  }
};
</script>
